export const boardType = {
  notice: '공지사항',
  event: '이벤트',
};
